import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/views/Index'
import Learn from '@/views/Learn'
import Exam from '@/views/Exam'
import Online from '@/views/Online'
import Rule from '@/views/Rule'
import DownLoad from '@/views/DownLoad'
import Dynamic from '@/views/Dynamic'
import Center from '@/views/Center'
import Sign from '@/views/Sign'
import Professor from '@/views/Professor'
import Transfer from '@/views/Transfer'
import Lecture from '@/views/Lecture'
import Contact from '@/views/Contact'
import TestRequest from '@/views/TestRequest'
import ExamRequest from '@/views/ExamRequest'
import Question from '@/views/Question'
import Msg from '@/views/Msg'
import RuleArticle from '@/views/RuleArticle'
import WorkArticle from '@/views/WorkArticle'
import Test from '@/views/Test'
import Expert from '@/views/Expert'
import ProblemLibrary from '@/views/ProblemLibrary'
import Examination from '@/views/Examination'
import AuditionVideo from '@/views/AuditionVideo'
import Audition from '@/views/Audition'
import Video from '@/views/Video'
import Course from '@/views/Course'
import Interview from '@/views/Interview'
import AuditionList from '@/views/AuditionList'
import Announcement from '@/views/Announcement'
import AnnouncementArticle from '@/views/AnnouncementArticle'
import AssociationNews from '@/views/AssociationNews'
import Elective from '@/views/Elective'
import Information from '@/views/Information'
import InformationArticle from '@/views/InformationArticle'
import Policy from '@/views/Policy'
import PolicyArticle from '@/views/PolicyArticle'



Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'Index',
      component: Index,
      meta: {
        tab: '首页'
      }
    },
    {
      path: '/Learn',
      name: 'Learn',
      component: Learn,
      meta: {
        tab: '学习',
        requiresAuth: true
      }
    },
    {
      path: '/Elective',
      name: 'Elective',
      component: Elective,
      meta: {
        tab: '选修课程',
        requiresAuth: true
      }
    },
    {
      path: '/Exam',
      name: 'Exam',
      component: Exam,
      meta: {
        tab: '测试',
        requiresAuth: true
      }
    },
    {
      path: '/Online',
      name: 'Online',
      component: Online,
      meta: {
        tab: '在线考试',
        requiresAuth: true
      }
    },
    {
      path: '/AssociationNews',
      name: 'AssociationNews',
      component: AssociationNews,
      meta: {
        tab: '协会动态'
      }
    },
    {
      path: '/Interview/:interviewId',
      name: 'Interview',
      component: Interview,
      meta: {
        tab: '协会动态'
      }
    },
    {
      path: '/Dynamic',
      name: 'Dynamic',
      component: Dynamic,
      meta: {
        tab: '行业新闻'
      }
    },
    {
      path: '/WorkArticle/:workid',
      name: 'WorkArticle',
      component: WorkArticle,
      meta: {
        tab: '行业新闻'
      }
    },
    {
      path: '/Rule',
      name: 'Rule',
      component: Rule,
      meta: {
        tab: '行业法规'
      }
    },
    {
      path: '/RuleArticle/:ruleid',
      name: 'RuleArticle',
      component: RuleArticle,
      meta: {
        tab: '行业法规'
      }
    },
    {
      path: '/DownLoad',
      name: 'DownLoad',
      component: DownLoad,
      meta: {
        tab: '下载中心'
      }
    },
    {
      path: '/Announcement',
      name: 'Announcement',
      component: Announcement,
      meta: {
        tab: '通知公告'
      }
    },
    {
      path: '/Information',
      name: 'Information',
      component: Information,
      meta: {
        tab: '公示公告',
        requiresAuth: true
      }
    },
    {
      path: '/Policy',
      name: 'Policy',
      component: Policy,
      meta: {
        tab: '政策法规',
        requiresAuth: true
      }
    },
    {
      path: '/AnnouncementArticle/:AnnouncementArticleId',
      name: 'AnnouncementArticle',
      component: AnnouncementArticle,
      meta: {
        tab: '通知公告'
      }
    },
     // PolicyArticle
     {
      path: '/PolicyArticle/:PolicyArticleId',
      name: 'PolicyArticle',
      component: PolicyArticle,
      meta: {
        tab: '政策法规'
      }
    },
    {
      // InformationArticle
      path: '/InformationArticle/:InformationArticleId',
      name: 'InformationArticle',
      component: InformationArticle,
      meta: {
        tab: '考试信息'
      }
    },
    {
      path: '/Lecture',
      name: 'Lecture',
      component: Lecture,
      meta: {
        tab: '学习指南'
      }
    },
    {
      path: '/TestRequest',
      name: 'TestRequest',
      component: TestRequest,
      meta: {
        tab: '学习指南'
      }
    },
    {
      path: '/ExamRequest',
      name: 'ExamRequest',
      component: ExamRequest,
      meta: {
        tab: '学习指南'
      }
    },
    {
      path: '/Question',
      name: 'Question',
      component: Question,
      meta: {
        tab: '学习指南'
      }
    },
    {
      path: '/Professor',
      name: 'Professor',
      component: Professor,
      meta: {
        tab: '专家介绍'
      }
    },
    {
      path: '/Transfer',
      name: 'Transfer',
      component: Transfer,
      meta: {
        tab: '在线转账'
      }
    },
    {
      path: '/Contact',
      name: 'Contact',
      component: Contact,
      meta: {
        tab: '联系我们'
      }
    },
    {
      path: '/Center',
      name: 'Center',
      component: Center,
      meta: {
        tab: '个人中心',
        requiresAuth: true
      }
    },
    {
      path: '/Sign',
      name: 'Sign',
      component: Sign,
      meta: {
        tab: '学习指南'
      }
    },
    {
      path: '/Msg',
      name: 'Msg',
      component: Msg,
      meta: {
        tab: '学习指南',
        requiresAuth: true
      }
    },
    {
      path: '/Expert/:expertid',
      name: 'Expert',
      component: Expert,
      meta: {
        tab: '专家详情'
      }
    },
    {
      path: '/Test/:exerciseId',
      name: 'Test',
      component: Test,
      meta: {
        tab: '测试'
      }
    },
    {
      path: '/ProblemLibrary/:exerciseId',
      name: 'ProblemLibrary',
      component: ProblemLibrary,
      meta: {
        tab: '测试'
      }
    },
    {
      path: '/Examination/:examId',
      name: 'Examination',
      component: Examination,
      meta: {
        tab: '在线考试'
      }
    },
    {
      path: '/AuditionVideo',
      name: 'AuditionVideo',
      component: AuditionVideo,
      meta: {
        tab: '视频页'
      }
    },
    {
      path: '/Audition/:auditionType/:auditionId',
      name: 'Audition',
      component: Audition,
      meta: {
        tab: '视频页'
      }
    },
    {
      path: '/AuditionList/:auditionType',
      name: 'AuditionList',
      component: AuditionList,
      meta: {
        tab: '视频页'
      }
    },
    {
      path: '/Video',
      name: 'Video',
      component: Video,
      meta: {
        tab: '学习'
      }
    },
    {
      path: '/Course/:contentId',
      name: 'Course',
      component: Course,
      meta: {
        tab: '学习',
        requiresAuth: true
      }
    },

  ],
  scrollBehavior(to, from, savedPosition) {
    return {
      x: 0,
      y: 0
    };
    // if (to.hash) {
    //   return {
    //     selector: to.hash
    //   }
    // }

  }
})



// WEBPACK FOOTER //
// ./src/router/index.js